import {
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import CustomLabel from "./CustomLabel";

type Props = {
  form: any;
  name: string;
  label: string;
  placeholder: string;
  bgError?: string;
  textError?: string;
  type?: any;
  pattern?: string;
  ref?: string;
  inputmode?:
    | "search"
    | "text"
    | "email"
    | "tel"
    | "url"
    | "none"
    | "numeric"
    | "decimal";
};

const CustomHeaderInput = ({
  form,
  name,
  placeholder,
  label,
  bgError,
  textError,
  type,
  pattern,
  inputmode,
}: Props) => {
  return (
    <div className="grid w-full items-center gap-1.5">
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FormItem>
            <FormControl className="">
              <Input
                placeholder={placeholder}
                id={field.name}
                type={type}
                multiple={type === "file" ? true : false}
                {...field}
                className={`${
                  bgError ? bgError : "aria-invalid:bg-red/10"
                } border-transparent bg-transparent !px-1 !py-0 text-xl font-semibold text-white !outline-none placeholder:text-xl placeholder:font-light focus:border-transparent focus:outline-none`}
              />
            </FormControl>
            <div className="h-0.5 w-full bg-white/50" />
            <FormMessage
              className={`${textError ? textError : "text-white/50"}`}
            />
          </FormItem>
        )}
      />
    </div>
  );
};

export default CustomHeaderInput;
